import { v4 as uuidv4 } from "uuid";

import type { AppSchema, ComponentNode, DataModel, Page } from "@shared/types";

import { componentMaterials, getMaterial } from "./materials";

export function createDefaultApp(tenantId: string): AppSchema {
  return {
    id: uuidv4(),
    name: "未命名应用",
    version: "0.1.0",
    tenantId,
    pages: [createDefaultPage()],
    dataModels: [],
    dataSources: [
      {
        id: uuidv4(),
        name: "Supabase 主库",
        type: "supabase",
        config: { url: import.meta.env.VITE_SUPABASE_URL || "" },
      },
    ],
    workflows: [],
    theme: {
      primaryColor: "#0f172a",
      borderRadius: "0.5rem",
      darkMode: false,
    },
    permissions: [
      { role: "admin", resource: "*", action: "*" },
      { role: "user", resource: "*", action: "read" },
    ],
  };
}

export function createDefaultPage(): Page {
  return {
    id: uuidv4(),
    name: "首页",
    route: "/",
    title: "首页",
    layout: createComponentNode("Container", { props: { padding: "24px" } }),
  };
}

export function createComponentNode(type: string, overrides: Partial<ComponentNode> = {}): ComponentNode {
  const material = getMaterial(type);
  const props = material
    ? Object.fromEntries(material.propSchema.map((p) => [p.name, p.defaultValue]))
    : {};
  return {
    id: uuidv4(),
    type,
    props,
    children: material?.allowChildren ? [] : undefined,
    ...overrides,
  };
}

export function createDefaultDataModel(): DataModel {
  return {
    id: uuidv4(),
    name: "新数据表",
    tableName: "new_table",
    fields: [
      { id: uuidv4(), name: "id", type: "uuid", required: true, primaryKey: true },
      { id: uuidv4(), name: "created_at", type: "datetime", required: true },
    ],
  };
}

export { componentMaterials, getMaterial };
